import React from 'react'
import { Redirect } from 'react-router-dom'
import { useAppContext } from "../../Context";
import '../../index.css'

/**
 * Container component for the logout process.
 * Clears SessionStorage and redirects to authentication page.
*/
const LogoutContainer = () => {
    const { userHasAuthenticated } = useAppContext();

    const logout = () => {
        sessionStorage.setItem("usename", "")
        sessionStorage.setItem("loginInformation", null)
        sessionStorage.setItem("isAuthenticated", "false")
        userHasAuthenticated(false)

        return (
            <Redirect to="/authentication" />
        )
    }

    return (
        logout()
    )
}

export { LogoutContainer }